import React, { useEffect } from "react";
import { useHistory } from "react-router";
// import Container from "@material-ui/core/Container";
import Pagination from "@material-ui/lab/Pagination";
import Grid from "@material-ui/core/Grid";
import OfferCard from "~/components/block/OfferCard";
import { LinkButton } from "~CJS/atoms/LinkButton";

import { initialize, GetMyOfferList, offer_set } from "~stores/TALENTBANK/Offer";
import { BackButton } from "~CJS/atoms/BackButton";

import {
    Stepper,
    Step,
    StepLabel,
    Card,
    CardContent,
    Box,
    Container
} from '@material-ui/core';
import { CheckCircle, Edit, Visibility } from '@material-ui/icons';


import { useDispatch, useSelector } from "react-redux";
import Typography from "@material-ui/core/Typography";

const MyOfferList = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const OfferState = useSelector((state) => state.Offer);

    const handleChangePage = (event, new_page) => {
        const view_info = { page: new_page, status: '01' };

        // dispatch(offer_set(["my_offer_view_info", view_info]));
        dispatch(GetMyOfferList(view_info));
    };

    useEffect(() => {
        dispatch(initialize());
        dispatch(GetMyOfferList({ page: OfferState.my_offer_view_info.page, status: '01' }));
    }, []);

    return (
        <React.Fragment>
            <Grid container direction="row" justifyContent="space-between" alignItems="center">
                <BackButton history={history} />
                <LinkButton label="お仕事作成" to="/sponsor/OfferNew" />
            </Grid>

            <WorkflowStepper />

            <Typography variant="h1">お仕事一覧 </Typography>
            <Grid container direction="row" justifyContent="space-evenly">
                {OfferState?.my_offer_list && (
                    <>
                        {OfferState.my_offer_list.map((item, index) => (
                            <React.Fragment key={index}>
                                <OfferCard data={item} />
                            </React.Fragment>
                        ))}
                    </>
                )}
            </Grid>
            {OfferState?.my_offer_view_info?.page_count > 1 && (
                <Grid container direction="row" justifyContent="center" alignItems="center">
                    <Pagination
                        shape="rounded"
                        count={OfferState.my_offer_view_info.page_count}
                        variant="outlined"
                        page={OfferState.my_offer_view_info.page}
                        color="secondary"
                        onChange={handleChangePage}
                    />
                </Grid>
            )}
        </React.Fragment>
    );
};


const steps = [
    { label: '作成・申請', icon: <Edit color="primary" /> },
    { label: '管理者が承認', icon: <CheckCircle color="secondary" /> },
    { label: '公開', icon: <Visibility color="success" /> },
];

function WorkflowStepper() {
    return (
        <Container maxWidth="sm">
            <Card variant="outlined" sx={{ mt: 4, p: 3, borderRadius: 4, boxShadow: 3 }}>
                <CardContent>
                    {/* <Typography variant="h5" gutterBottom textAlign="center">
                        作業フロー
                    </Typography> */}
                    <Stepper alternativeLabel activeStep={2}>
                        {steps.map((step, index) => (
                            <Step key={index}>
                                <StepLabel icon={step.icon}>
                                    <Typography variant="body1">{step.label}</Typography>
                                </StepLabel>
                            </Step>
                        ))}
                    </Stepper>

                </CardContent>
            </Card>
        </Container>
    );
}
export default MyOfferList;
